/** 打开外链
 * web端：直接打开空白页
 * 插件端：使用客户默认的浏览器打开页面
 * **/

import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      cacheFileName: ''
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
  },
  methods: {
    async openUrl(url, needLogin = false, type = '_blank',) {
      if (this.platform === 'web') {
        window.open(url, type)
      } else {
        if (needLogin) {
          const webUrl = await this.$api.user.ssoUrl({ dest: url })
          await this.$desktopClient.NavigateToBrowser(webUrl)
        } else {
          this.$desktopClient.NavigateToBrowser(url)
        }
      }
    }
  }
}
